import QRCode from "qrcode";
import jsQR from "jsqr";

// Groot belge-no QR formatı: "GROOT1|<type>|<doc_no>"
const PREFIX = "GROOT1";

export async function qrDataUrl(text, size = 140) {
  try {
    return await QRCode.toDataURL(String(text), { width: size, margin: 1, errorCorrectionLevel: "M" });
  } catch {
    return "";
  }
}

export function encodeDocNoQr(type, docNo) {
  return `${PREFIX}|${type || ""}|${docNo}`;
}

// QR metnini belge no'ya çözer (Groot formatı veya düz belge-no deseni).
export function parseDocNoQr(text) {
  if (!text) return null;
  const s = String(text).trim();
  if (s.startsWith(PREFIX + "|")) {
    const parts = s.split("|");
    return { type: parts[1] || null, doc_no: parts[2] || null };
  }
  if (/^[A-Z]{2,8}-\d{6,8}-\d{3,6}$/.test(s)) return { type: null, doc_no: s };
  return null;
}

// Yüklenen GÖRSEL dosyasındaki QR'ı çözer (pdf/word desteklenmez → null).
export async function scanQrFromFile(file) {
  if (!file || !/^image\//.test(file.type || "")) return null;
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((res, rej) => {
      const i = new Image();
      i.onload = () => res(i);
      i.onerror = rej;
      i.src = url;
    });
    const maxDim = Math.max(img.naturalWidth || img.width, img.naturalHeight || img.height, 1);
    const scale = Math.min(1400 / maxDim, 1) || 1;
    const w = Math.max(1, Math.round((img.naturalWidth || img.width) * scale));
    const h = Math.max(1, Math.round((img.naturalHeight || img.height) * scale));
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, w, h);
    const data = ctx.getImageData(0, 0, w, h);
    const code = jsQR(data.data, w, h, { inversionAttempts: "attemptBoth" });
    return code?.data || null;
  } catch {
    return null;
  } finally {
    URL.revokeObjectURL(url);
  }
}
